import "./assets/css/site.css";
import Router from "./router/router";
import { BrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./store/store";
import "./i18n";
import { initTheme } from "./theme";
initTheme();

document.documentElement.classList.add("js");

const App = () => (
  <Provider store={store}>
    <BrowserRouter>
      <Router />
    </BrowserRouter>
  </Provider>
);

createRoot(document.getElementById("root")).render(<App />);
